import {
    TABLE_LOADING_SET,
    TABLE_DATA_CLEAR,
    TABLE_DATA_IMPORT,
    TABLE_SORT_TOGGLE,
    TABLE_SELECT_ROW,
    TABLE_SELECT_ROWS,
    TABLE_DELETE_ROWS_SUCCESS,
    TABLE_DELETE_ROWS_FAILURE
} from '../actions';
import importData from './importData';
import toggleSortingOrder from './toggleSortingOrder';
import selectRow from './selectRow';
import selectRows from './selectRows';

const defaultInitialState = {
    header: [],
    rows: [],
    selectedRows: [],
    meta: {
        currencies: []
    },
    requestId: 0,
    loading: false,
    failure: false,
    initialized: false
};

export default function reducer(state = defaultInitialState, action) {
    switch (action.type) {
        case TABLE_DATA_IMPORT:
            return importData(state, action);
        case TABLE_DATA_CLEAR:
            return Object.assign({}, state, {
                loading: false,
                initialized: false,
                rows: [],
                selectedRows: [],
                meta: {
                    currencies: []
                }
            });
        case TABLE_SORT_TOGGLE:
            return toggleSortingOrder(state, action);
        case TABLE_SELECT_ROW:
            return selectRow(state, action);
        case TABLE_SELECT_ROWS:
            return selectRows(state, action);
        case TABLE_LOADING_SET:
            return Object.assign({}, state, {
                loading: action.loading
            });
        case TABLE_DELETE_ROWS_SUCCESS:
            return Object.assign({}, state, {
                selectedRows: [],
                loading: false
            });
        case TABLE_DELETE_ROWS_FAILURE:
            return Object.assign({}, state, {
                loading: false,
                failure: true
            });
        default:
            return state;
    }
}

export function createReducer(stateKey, initialState = {}) {
    return (
        state = Object.assign({},
            defaultInitialState,
            Object.keys(initialState).length ?
            { ...initialState, initialized: true } :
            initialState
        ),
        action
    ) => {
        if (!action.stateKey || action.stateKey !== stateKey) {
            return state;
        }

        return reducer(state, action);
    };
}



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/reducers/index.js